import React, { useEffect, useState } from "react";
import { FaStar } from "react-icons/fa";
import socketService from "../Utils/socketService";
import { useDispatch } from "react-redux";
import { getActivitiesData } from "../Redux/Action";
import { useAppTheme } from "../Hooks/useAppTheme";

export const LatestActivity = ({ userID, getActivityLoading }) => {
  const theme = useAppTheme();
  const [activities, setActivities] = useState([]);
  const [loading, setLoading] = useState(false);
  const dispatch = useDispatch();

  // Function to remove consecutive duplicates based only on message text
  const removeConsecutiveDuplicates = (activitiesArray) => {
    if (!Array.isArray(activitiesArray) || activitiesArray.length === 0) return [];
    
    return activitiesArray.filter((activity, index, self) => {
      // Always include the first item
      if (index === 0) return true;
      
      // Compare with the previous item based only on message
      const prevActivity = self[index - 1];
      return activity.message !== prevActivity.message;
    });
  };

  useEffect(() => {
    setLoading(true);
    dispatch(
      getActivitiesData({
        payload: userID,
        callback: (data) => {
          setLoading(false);
          if (data?.code === 200 && Array.isArray(data.data)) {
            // Remove consecutive duplicates from initial data
            const uniqueActivities = removeConsecutiveDuplicates(data.data.slice(0, 10));
            setActivities(uniqueActivities);
          } else {
            setActivities([]);
          }
        },
      })
    );

    const handleNewActivity = (activity) => {
      setActivities((prev) => {
        const updated = [activity, ...prev];
        // Remove consecutive duplicates when adding new activity
        return removeConsecutiveDuplicates(updated).slice(0, 10);
      });
    };

    socketService.on("newActivity", handleNewActivity);

    return () => {
      socketService.off("newActivity", handleNewActivity);
    };
  }, [dispatch, userID]);


  return (
    <div className="rounded-xl shadow p-6" style={{ backgroundColor: theme.bgCard }}>
      <h2 className="text-sm font-semibold mb-4" style={{ color: theme.textPrimary }}>Latest Activity</h2>

      {getActivityLoading ? (
        <div className="text-center text-xs py-4" style={{ color: theme.textSecondary }}>Loading activities...</div>
      ) : activities.length === 0 ? (
        <div className="flex items-center justify-center h-32">
          <div className="text-center text-sm" style={{ color: theme.textTertiary }}>
            No recent Activity
          </div>
        </div>
      ) : (
        <ul className="space-y-3 text-xs" style={{ color: theme.textPrimary }}>
          {activities.map((activity, idx) => {
            const date = new Date(activity.timestamp);
            const formattedDate = `${date.toLocaleDateString()} ${date.toLocaleTimeString()}`;

            return (
              <li key={activity._id || idx} className="flex items-start gap-2">
                <div className="mt-0.5 text-xs" style={{ color: theme.brandAccent }}>
                  <FaStar />
                </div>
                <div className="flex-1">
                  <div className="font-medium" style={{ color: theme.textPrimary }}>{activity.message}</div>
                  <div className="text-[10px]" style={{ color: theme.textTertiary }}>{formattedDate}</div>
                </div>
              </li>
            );
          })}
        </ul>
      )}
    </div>
  );
};